<template>
    <b-card no-body>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    search
                    pagination="server"></v-table>
    </b-card>
</template>

<script>
import { BCard,BFormCheckbox } from 'bootstrap-vue'
import { AgreementApi } from '@/api/agreement'
export default {
    components:{
        BCard,
        BFormCheckbox
    },
    data(){
        return{
            editing:false,
            loading:false,
            fields:[
                {name:'Dış Anlaşma No',key:'AgreementCode',sortable:true, thClass:'w-25'},
                {name:'Dış Anlaşma Adı',key:'Name',sortable:true, thClass:'w-25',tdClass:'text-nowrap'},
                {name:'Cari Kodu',key:'CariCode',sortable:true, thClass:'w-25'},
                {name:'Cari',key:'CariName',sortable:true, thClass:'w-25',tdClass:'text-nowrap'},
            ],
            buttons:[
                { text:"Detay Görüntüle",key:"view",icon:"EyeIcon",variant:"secondary",action:this.detail },
                { text:"Oransal Fiyat artışı",key:"price-history",icon:"ActivityIcon",variant:"primary",action:this.priceHistory },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            firm:{
                Id:null,
                Name: null,
                AgreementCode:null,
                FirmId:null,
                VehicleTypeId:null,
                AgreementRoutePrices:[]
            }
        }
    },
    methods:{
        provider(data){
            return AgreementApi.Out.Table(data)
        },
        createNew(){
            this.$router.push({name:'out-agreement-create'})
        },
        detail(item){
            this.$router.push({name:'out-agreement-detail',params:{id:item.Id}})
        },
        priceHistory(item){
            this.$router.push({name:'out-agreement-price-history',params:{id:item.Id}})
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem  ${item.CariCode} kodlu cariye ait olan ${item.Name} adlı sözleşmeyi silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    AgreementApi.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                        
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>